import MainNav from './../modules/mainNav';
import ScrollHeader from './../modules/scrollHeader';
import Newsletter from './../modules/newsletter';
import CookieConsent from './../modules/cookie-consent';
import Slider from "./../modules/slider";
import ProductFilter from "../modules/productFilter";
import ProductsShowMore from "../modules/product-show-more";
import Toggle from "../modules/toggle";
import TrackEvents from "../modules/track-events";
import Modal from "../modules/modal";

const modules = [
  MainNav,
  ScrollHeader,
  Slider,
  Newsletter,
  CookieConsent,
  Toggle,
  ProductFilter,
  ProductsShowMore,
  TrackEvents,
  Modal,
]

export default {
  init() {
    modules.forEach(module => {
      if (module['init']) {
        module.init();
      }
    })
    this.addBodyHeightClass();
  },

  addBodyHeightClass() {
    if (document.body.scrollHeight > 1600 ) {
        document.body.classList.add('is-large-tall-page');
        return;
    }
    if (document.body.scrollHeight > 1200) {
        document.body.classList.add('is-medium-tall-page');
        return;
    }
  },
};
